import { Sale, PaymentOption, PaymentMethodCode } from '@src/core/buyerApiClient';
import { BRASPAG_3DS_STATUS } from '@src/features/payment';

declare let __APP_ENV__: string;

export interface ExternalAuthenticationResponse {
  data?: any;
}

const handleExternalAuthentication = async (
  widgetUrl: string,
  pm: PaymentOption,
  sale: Sale,
  data: any,
): Promise<ExternalAuthenticationResponse | null> => {
  switch (pm.externalAuthentication?.type) {
    case 'bpmpi':
      return await handleBraspagMpi(widgetUrl, pm, sale, data);
    default:
      return null;
  }
};

const handleBraspagMpi = (
  widgetUrl: string,
  pm: PaymentOption,
  sale: Sale,
  data: any,
): Promise<ExternalAuthenticationResponse> => {
  const wdw: any = window;
  const { body } = document;
  const div = mountInputValues(pm, sale, data);

  const handleReturn = (done: (r: ExternalAuthenticationResponse) => void, data?: any) => {
    wdw.bpmpi_config = null;
    body.removeChild(div);

    done({ data });
  };

  return new Promise((done, _) => {
    wdw.bpmpi_config = () => ({
      onReady() {
        wdw.bpmpi_authenticate();
      },
      onSuccess(e: any) {
        handleReturn(done, { e, status: BRASPAG_3DS_STATUS.success });
      },
      onFailure(e: any) {
        handleReturn(done, { e, status: BRASPAG_3DS_STATUS.failure });
      },
      onUnenrolled(e: any) {
        handleReturn(done, { e, status: BRASPAG_3DS_STATUS.unenrolled });
      },
      onDisabled(e: any) {
        handleReturn(done, { e, status: BRASPAG_3DS_STATUS.disabled });
      },
      onError(e: any) {
        handleReturn(done, { e, status: BRASPAG_3DS_STATUS.error });
      },
      onUnsupportedBrand(e: any) {
        handleReturn(done, { e, status: BRASPAG_3DS_STATUS.unsuportedBrand });
      },
      Environment: __APP_ENV__ === 'production' ? 'PRD' : 'SDB',
      //Debug: __APP_ENV__ !== 'production',
      Debug: true,
    });

    const script = document.createElement('script');
    script.src = `${widgetUrl}BP.Mpi.3ds20.min.js`;
    div.appendChild(script);

    body.appendChild(div);
  });
};

const paymentCodes: { [key: string]: string } = {
  [PaymentMethodCode.CreditCard]: 'Credit',
  [PaymentMethodCode.DebitCard]: 'Debit',
};

const mountInputValues = (pm: PaymentOption, sale: Sale, data: any): HTMLElement => {
  const opt = pm.installmentOptions.find((io) => io.division == data.payment_card.installments)!;
  const div = document.createElement('div');

  createBraspagMpiInput(div, 'auth', 'true');
  createBraspagMpiInput(div, 'accesstoken', pm.externalAuthentication!.data['access_token']);
  createBraspagMpiInput(div, 'ordernumber', `${sale.id}`);
  createBraspagMpiInput(div, 'currency', 'BRL');

  createBraspagMpiInput(div, 'totalamount', `${opt.amountCents}`);
  createBraspagMpiInput(div, 'installments', data.payment_card.installments);
  createBraspagMpiInput(div, 'paymentmethod', paymentCodes[pm.paymentMethod.code]!);
  createBraspagMpiInput(div, 'cardnumber', data.payment_card.card_number);
  createBraspagMpiInput(div, 'cardexpirationmonth', data.payment_card.validity_month);
  createBraspagMpiInput(div, 'cardexpirationyear', data.payment_card.validity_year);
  //createBraspagMpiInput(div, 'cardalias', data.payment_card.holder);

  createBraspagMpiInput(div, 'order_productcode', 'PHY');
  createBraspagMpiInput(div, 'merchant_url', window.location.origin);

  return div;
};

const createBraspagMpiInput = (el: HTMLElement, name: string, value: string) => {
  const input = document.createElement('input');

  input.type = 'hidden';
  input.name = input.className = `bpmpi_${name}`;
  input.value = value;

  el.appendChild(input);
};

export default handleExternalAuthentication;
